<template>
  <div id="nav-center">
    <div class="sep section-center">
      <slot name="center"></slot>
    </div>
    <div class="sep section-side">
      <slot name="side"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.sep {
  margin: auto;
}

.section-center {
  width: 75%;
  @media screen and (max-width: 800px) {
    width: 60%;
  }
  @media screen and (max-width: 600px) {
    width: 75%;
  }
}

.section-side {
  width: 25%;
  border-right: 0;
  @media screen and (max-width: 800px) {
    width: 40%;
  }
  @media screen and (max-width: 600px) {
    width: 25%;
  }
}

#nav-center {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
  display: flex;
  justify-content: space-between;
  width: 99%;
  align-items: stretch;
  margin-right: auto;
}
</style>

<style lang="scss">
.on-small-screen {
  display: none;
}
@media screen and (max-width: 600px) {
  .section-side {
    width: 10%;
    .input-group {
      display: none;
    }
    .on-small-screen {
      display: block;
    }
    // visualizza al click
    .on-small-screen:active + .input-group,
    &:hover .input-group,
    &:active .input-group,
    .input-group:active,
    .input-group:hover {
      display: flex;
      padding: 5%;
      margin: 0;
      position: absolute;
      width: 100vw;
      left: 0;
      .form-control {
        width: auto;
      }
    }
    .on-small-screen {
      display: flex;
    }
    .on-big-screen {
      display: none;
    }
  }
  .section-center {
    width: 90%;
  }
}
</style>

<script lang="ts">
export default {
  setup() {
    const data = {};
    return { ...data };
  },
};
</script>
